import type { AppNavGroup, AppUser } from "@/config/appNav";

export const AGENCE_NAV_GROUPS: AppNavGroup[] = [
  {
    items: [{ label: "Tableau de bord", to: "/agence", icon: "ri-dashboard-3-line" }],
  },
  {
    title: "Gestion",
    items: [
      { label: "Propriétaires", to: "/agence/proprietaires", icon: "ri-user-star-line", permission: "proprietaires.voir" },
      { label: "Immeubles", to: "/agence/immeubles", icon: "ri-building-2-line", permission: "immeubles.voir" },
      { label: "Biens", to: "/agence/biens", icon: "ri-home-4-line", permission: "biens.voir" },
      { label: "Locataires", to: "/agence/locataires", icon: "ri-user-3-line", permission: "locataires.voir" },
      { label: "Contrats", to: "/agence/contrats", icon: "ri-file-text-line", permission: "contrats.voir" },
    ],
  },
  {
    title: "Finances",
    items: [
      { label: "Loyers", to: "/agence/loyers", icon: "ri-wallet-3-line", permission: "loyers.voir" },
      { label: "Paiements", to: "/agence/paiements", icon: "ri-hand-coin-line", permission: "paiements.voir" },
      { label: "Impayés", to: "/agence/impayes", icon: "ri-alert-line", permission: "impayes.voir" },
      { label: "Dépenses", to: "/agence/depenses", icon: "ri-money-cny-circle-line", permission: "depenses.voir" },
    ],
  },
  {
    title: "Suivi",
    items: [
      { label: "Maintenance", to: "/agence/maintenance", icon: "ri-tools-line", permission: "maintenance.voir" },
      { label: "Documents", to: "/agence/documents", icon: "ri-folder-line", permission: "documents.voir" },
      { label: "Rapports", to: "/agence/rapports", icon: "ri-file-chart-line", permission: "rapports.voir" },
      { label: "Statistiques", to: "/agence/statistiques", icon: "ri-bar-chart-box-line", permission: "statistiques.voir" },
    ],
  },
  {
    title: "Organisation",
    items: [{ label: "Employés", to: "/agence/employes", icon: "ri-team-line", permission: "employes.voir" }],
  },
  {
    title: "Compte",
    items: [
      { label: "Abonnement", to: "/agence/abonnement", icon: "ri-vip-diamond-line", permission: "parametres.voir" },
      { label: "Mes paiements", to: "/agence/mes-paiements", icon: "ri-history-line", permission: "parametres.voir" },
      { label: "Paramètres", to: "/agence/parametres", icon: "ri-settings-3-line", permission: "parametres.voir" },
    ],
  },
];

// Identité de repli neutre : l'espace affiche l'utilisateur réellement connecté.
export const AGENCE_USER: AppUser = {
  name: "",
  role: "Directrice d'agence",
  initials: "",
};

/**
 * Filtre les groupes de navigation de l'espace Agence selon les permissions.
 * Un item sans permission est toujours visible ; sinon la permission doit être accordée.
 * Les groupes devenus vides sont retirés.
 */
export function filterAgenceNavGroups(
  groups: AppNavGroup[],
  hasPermission: (permission: string) => boolean
): AppNavGroup[] {
  return groups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => !item.permission || hasPermission(item.permission)),
    }))
    .filter((group) => group.items.length > 0);
}